/**
 * SectionRole_Entity type guard.
 *
 * @param {any} sectionRoleJson SectionRole object from API
 * @returns {boolean} Return true if type is SectionRole_Entity
 */
function validator(
  sectionRoleJson: unknown
): sectionRoleJson is SectionRole_Entity {
  if (typeof sectionRoleJson === "object" && sectionRoleJson != null) {
    SectionRole_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(sectionRoleJson).includes(element))
        throw new Error(`Field ${element} is null or undefined`);
    });
  }
  return true;
}

export default class SectionRole_Entity {
  static requiredFields = ["id"];

  constructor(sectionRoleJson: unknown) {
    if (validator(sectionRoleJson)) {
      this.id = sectionRoleJson.id;
      this.name = sectionRoleJson.name;
      this.createdAt = sectionRoleJson.createdAt;
      this.updatedAt = sectionRoleJson.updatedAt;
      this.position = sectionRoleJson.position;
    } else
      throw new Error(
        `Failed to create new instance of ${SectionRole_Entity.name}`
      );
  }

  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  position: number;
}
